import {
  HOME_PAGE_URL,
  ABOUT_ME_PAGE_URL,
  GALLERY_PAGE_URL,
  SERVICES_PAGE_URL,
  CONTACT_PAGE_URL,
  REVIEWS_PAGE_URL,
} from '../Constants';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_ME_PAGE_URL, label: 'About Me' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: SERVICES_PAGE_URL, label: 'Services' },
  { path: REVIEWS_PAGE_URL, label: 'Reviews' },
  { path: CONTACT_PAGE_URL, label: 'Contact Me' },
];
